var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertCircleRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 19,
    height: 19,
    rx: 9.5,
    fill: "#292929"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0002 4.33333C9.68162 4.33333 8.39269 4.72433 7.29636 5.45687C6.20004 6.18941 5.34555 7.2306 4.84097 8.44878C4.33638 9.66695 4.20436 11.0074 4.4616 12.3006C4.71883 13.5938 5.35377 14.7817 6.28612 15.714C7.21847 16.6464 8.40636 17.2813 9.69956 17.5386C10.9928 17.7958 12.3332 17.6638 13.5514 17.1592C14.7696 16.6546 15.8108 15.8001 16.5433 14.7038C17.2758 13.6075 17.6668 12.3185 17.6668 11C17.6668 10.1245 17.4944 9.25761 17.1594 8.44878C16.8243 7.63994 16.3333 6.90501 15.7142 6.28595C15.0952 5.6669 14.3602 5.17583 13.5514 4.8408C12.7426 4.50577 11.8756 4.33333 11.0002 4.33333ZM11.0002 14.3333C10.8683 14.3333 10.7394 14.2942 10.6298 14.221C10.5202 14.1477 10.4347 14.0436 10.3842 13.9218C10.3338 13.8 10.3206 13.6659 10.3463 13.5366C10.372 13.4073 10.4355 13.2885 10.5288 13.1953C10.622 13.102 10.7408 13.0385 10.8701 13.0128C10.9994 12.9871 11.1335 13.0003 11.2553 13.0507C11.3771 13.1012 11.4812 13.1867 11.5545 13.2963C11.6277 13.4059 11.6668 13.5348 11.6668 13.6667C11.6668 13.8435 11.5966 14.013 11.4716 14.1381C11.3465 14.2631 11.177 14.3333 11.0002 14.3333ZM11.6668 11.6667C11.6668 11.8435 11.5966 12.013 11.4716 12.1381C11.3465 12.2631 11.177 12.3333 11.0002 12.3333C10.8234 12.3333 10.6538 12.2631 10.5288 12.1381C10.4037 12.013 10.3335 11.8435 10.3335 11.6667V8.33333C10.3335 8.15652 10.4037 7.98695 10.5288 7.86193C10.6538 7.7369 10.8234 7.66667 11.0002 7.66667C11.177 7.66667 11.3465 7.7369 11.4716 7.86193C11.5966 7.98695 11.6668 8.15652 11.6668 8.33333V11.6667Z",
    fill: "#FF4D42"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 19,
    height: 19,
    rx: 9.5,
    stroke: "#292929",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertCircleRed);
export default __webpack_public_path__ + "static/media/alert-circle-red.30a989b8429964eafcc02b55415ef594.svg";
export { ForwardRef as ReactComponent };